/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

import Spinner from '../../_utils/spinner';
import Button from '../../_common/button';

export default function LoadingPhotoPlaceholders({ index, total }) {
  const remainingUploads = Number(total) - Number(index);

  if (Number.isNaN(remainingUploads) || remainingUploads < 1) {
    return null;
  }

  return (
    <div data-test-id="list-view-desktop" className="list-view-desktop">
      {Array.from(Array(remainingUploads)).map((_, i) => {
        return (
          <section key={i} role="listitem" className="list-item">
            <div className="d-flex">
              <div className="flex-grow-1">
                <div className="d-inline-block list-item__preview">
                  <Spinner />
                  <div
                    role="toolbar"
                    className="list-item__controls d-flex justify-content-between align-items-center">
                    <Button
                      disabled
                      className="btn-link btn-underline edit-photo"
                      text="Edit"
                    />
                    <Button
                      disabled
                      hideLabel
                      className="btn-link remove-photo"
                      text="Delete"
                      icon="fa-trash-alt"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
}

LoadingPhotoPlaceholders.propTypes = {
  index: PropTypes.number,
  total: PropTypes.number,
};

LoadingPhotoPlaceholders.defaultProps = {
  index: 0,
  total: 0,
};
